// BorderTrailBox.jsx
// https://codepen.io/jh3y/pen/vYqLPaE?editors=1111
import React, { useEffect, useRef } from 'react';
import './BorderTrailBox.css';

const BorderTrailBox = ({
  className,
  children,
  mainStyles,
  asideStyles,
  trailColor,
  borderColor,
  borderRadius = 24,
  borderWidth = 3,
  trailSize = 25,
  speed = 6,
  explode = true
}) => {

	const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if(trailColor){el.style.setProperty('--accent', trailColor);}
    if(borderColor){el.style.setProperty('--border', borderColor);}
    el.style.setProperty('--border-radius', `${borderRadius}`);
    el.style.setProperty('--border-width', `${borderWidth}`);
    el.style.setProperty('--trail-size', `${trailSize}`);
    el.style.setProperty('--speed', `${speed}s`);
    /*
    if (explode) {
	    el.setAttribute('data-explode', 'true');
	  } else {
	    el.removeAttribute('data-explode');
	  }
	  */
  }, [trailColor, borderRadius, borderWidth, trailSize, speed]);

  return (
    <main className={` ${className}`} style={{...mainStyles}}>
      <aside className="fluid" ref={ref} style={{...asideStyles}}>
        <div className="border">
          <div className="trail"></div>
        </div>
        <div className="content" style={{ padding: "0" }}>
        	{children}
        </div>
      </aside>
    </main>
  );
};

export default BorderTrailBox;
